module.exports = __webpack_public_path__ + "static/media/purplePin.b36173c1.png";